// @ts-strict-ignore
import type { Action, ServiceObject, ServicesByName } from 'flow/store/engine/types';


export function getAttribute({
  actions, services, serviceActionId, attributeId,
}: {
  actions: Record<string, Action>;
  services: ServicesByName;
  serviceActionId: string;
  attributeId: number;
}) {
  const serviceAction = actions[serviceActionId];
  const service = services[serviceAction.service.internalName];
  const attribute = service.attributes[attributeId];

  return {
    service: serviceAction.service.internalName,
    attribute,
  };
}

export function isActionOptionAServiceSetting(opts: {
  optionName: string;
  service: ServiceObject;
}): boolean {
  const { optionName, service } = opts;
  const {
    credentialsSchema: {
      credentials,
    } = {},
  } = service;

  if (!credentials) {
    return false;
  }
  return Object.hasOwn(credentials, optionName);
}


export function isActionOptionAServiceSecret(opts: {
  optionName: string;
  service: ServiceObject;
}): boolean {
  const { optionName, service } = opts;
  const {
    credentialsSchema: {
      credential_format: { secrets } = {},
    } = {},
  } = service;

  if (!secrets) {
    return false;
  }

  return secrets.includes(optionName);
}

export function isActionOptionAServiceCredential(opts: {
  optionName: string;
  service: ServiceObject;
}): boolean {
  return isActionOptionAServiceSetting(opts) || isActionOptionAServiceSecret(opts);
}


export function getServiceKeyValuesAsString(opts: {
  serviceAction: Action;
  service: ServiceObject;
}): string {
  const { service, serviceAction } = opts;

  const { options } = serviceAction;

  const res = [];

  Object.entries(options).forEach(([optionName, option]) => {
    if (!isActionOptionAServiceCredential({ optionName, service })) {
      const optionAsString = `${optionName}/${option.value}`;
      res.push(optionAsString);
    }
  });


  return res.join(', ');
}

export function serviceHasAttributes(service: ServiceObject) {
  const { attributes } = service;
  return Object.values(attributes)?.length > 0;
}

export function isServicesASubsetOfServicesB(args: {
  servicesA: ServiceObject[];
  servicesB: ServiceObject[];
}): boolean {
  const { servicesA, servicesB } = args;

  const serviceInternalNamesSubset = new Set(servicesA.map(service => service.internal_name));
  const serviceInternalNamesSuperset = new Set(servicesB.map(service => service.internal_name));

  // check that every service in A is included in B
  return [...serviceInternalNamesSubset].every(sourceServiceName => (
    serviceInternalNamesSuperset.has(sourceServiceName)),
  );
}
